export default "__VITE_ASSET__DGP1FMAT__"